module.exports = __webpack_public_path__ + "img/ico_add--wh.be948c03.svg";